import { useIntl } from 'react-intl';

import {
  Button,
  type Props as ButtonProps,
} from '#src/atoms/buttons/Button/index.tsx';
import { FontAwesomeIcon } from '#src/atoms/icons/index.tsx';
import { iconChevronLeft } from '#src/atoms/icons/system/iconChevronLeft.ts';
import { glossary } from '#src/lib/glossary.ts';

type Props = {
  onBack?: () => void;
  color?: ButtonProps['color'];
  size?: ButtonProps['size'];
  to?: ButtonProps['to'];
  disabled?: boolean;
  className?: string;
};

export const BackButton = ({
  onBack,
  color = 'tertiary',
  size = 'small',
  to,
  disabled,
  className,
}: Props) => {
  const { formatMessage } = useIntl();
  return (
    <Button
      size={size}
      onClick={onBack}
      to={to}
      startIcon={<FontAwesomeIcon icon={iconChevronLeft} />}
      color={color}
      disabled={disabled}
      aria-label={formatMessage(glossary.back)}
      className={className}
    />
  );
};
